import {reactive} from "vue";

export default {
    install(app) {
        const state = reactive({
            message: '',
            color: 'success',
            timeout: 3000,
            visible: false,
        })

        const notifier = {
            show({ text, type = 'success', duration = 5000}) {
                state.message = text;
                state.type = type;
                state.timeout = duration;
                state.visible = true;
            },
            state
        }

        app.config.globalProperties.$notifier = notifier
        app.provide('notifier', notifier)
    }
}
